import { useState } from 'react';
import Validator from 'validatorjs';
import React, { useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import entidadesFederativas from '../../support/catalogs/EntidadesFederativas';

const estados = [{
  label: 'Selecciona',
  value: ''
}].concat(entidadesFederativas);

const ComplementoParcialesConstruccion = (props) => {

  const [data, setData] = useState(props.data || {});

  const [validation, setValidation] = useState({
    validator: new Validator({}, rules),
    isValid: false
  });

  const { isValid } = validation;

  const handleOnChange = (event) => {
    const newState = {
      ...data,
      ...event
    };

    setData(newState);
  }

  const handleOnInmuebleChange = (event) => {
    const { Inmueble = {} } = data;

    const newState = {
      ...data,
      Inmueble: {
        ...Inmueble,
        ...event
      }
    };

    setData(newState);
  }

  const validate = (data) => {
    const validator = new Validator(data, rules);

    setValidation({
      validator: validator,
      isValid: validator.passes()
    });
  }

  useEffect(() => {
    validate(data);
  }, [data]);

  const handleOnAdd = () => {
    const parcialesconstruccion = {
      Version: '1.0',
      ...data
    };

    props.onChange({ parcialesconstruccion });

    clearState();
  }

  const handleOnCancel = () => {
    props.onCancel('parcialesconstruccion');

    clearState();
  }

  const clearState = () => {
    setData({});
  }

  const { Inmueble = {} } = data;

  return (
    <>
      <div className="pb-4 text-right">
        <strong className="text-black text-upper">Complemento Servicios Parciales de Construcción</strong>
      </div>

      <div className="pb-4">
        <div className="section pt-2">

          <Form autoComplete="off">
              <Row>
                <Col sm md={ 6 }>
                  <FormControl type="text"
                    label="Permiso, licencia o autorización"
                    name="NumPerLicoAut"
                    placeholder=""
                    help=""
                    rules={ rules.NumPerLicoAut }
                    value={ data.NumPerLicoAut }
                    onChange={ handleOnChange }
                  />
                </Col>
              </Row>

              <div className="pb-3">
                <strong className="text-black">
                  Inmueble
                </strong>
              </div>

              <Row>
                <Col sm md={ 6 }>
                  <FormControl type="text"
                    label="Calle"
                    name="Calle"
                    placeholder=""
                    help=""
                    rules={ rules.Inmueble.Calle }
                    value={ Inmueble.Calle }
                    onChange={ handleOnInmuebleChange }
                  />
                </Col>

                <Col sm md={ 3 }>
                  <FormControl type="text"
                    label="Int."
                    name="NoExterior"
                    placeholder=""
                    help=""
                    rules={ rules.Inmueble.NoExterior }
                    value={ Inmueble.NoExterior }
                    onChange={ handleOnInmuebleChange }
                  />
                </Col>

                <Col sm md={ 3 }>
                  <FormControl type="text"
                    label="Ext."
                    name="NoInterior"
                    placeholder=""
                    help=""
                    rules={ rules.Inmueble.NoInterior }
                    value={ Inmueble.NoInterior }
                    onChange={ handleOnInmuebleChange }
                  />
                </Col>

              </Row>

              <Row>
                <Col sm md={ 3 }>
                  <FormControl type="text"
                    label="CP"
                    name="CodigoPostal"
                    placeholder=""
                    help=""
                    rules={ rules.Inmueble.CodigoPostal }
                    value={ Inmueble.CodigoPostal }
                    onChange={ handleOnInmuebleChange }
                  />
                </Col>

                <Col sm md={ 3 }>
                  <FormControl type="text"
                    label="Colonia"
                    name="Colonia"
                    placeholder=""
                    help=""
                    rules={ rules.Inmueble.Colonia }
                    value={ Inmueble.Colonia }
                    onChange={ handleOnInmuebleChange }
                  />
                </Col>

                <Col sm md={ 3 }>
                  <FormControl type="text"
                    label="Localidad"
                    name="Localidad"
                    placeholder=""
                    help=""
                    rules={ rules.Inmueble.Localidad }
                    value={ Inmueble.Localidad }
                    onChange={ handleOnInmuebleChange }
                  />
                </Col>

                <Col sm md={ 3 }>
                  <FormControl type="text"
                    label="Municipio"
                    name="Municipio"
                    placeholder=""
                    help=""
                    rules={ rules.Inmueble.Municipio }
                    value={ Inmueble.Municipio }
                    onChange={ handleOnInmuebleChange }
                  />
                </Col>
              </Row>

              <Row>
                <Col sm md={ 3 }>
                  <FormControl type="select"
                    label="Estado"
                    name="Estado"
                    placeholder=""
                    help=""
                    options={ estados }
                    rules={ rules.Inmueble.Estado }
                    value={ Inmueble.Estado }
                    onChange={ handleOnInmuebleChange }
                  />
                </Col>

                <Col sm md={ 9 }>
                  <FormControl type="text"
                    label="Referencia"
                    name="Referencia"
                    placeholder=""
                    help=""
                    rules={ rules.Inmueble.Referencia }
                    value={ Inmueble.Referencia }
                    onChange={ handleOnInmuebleChange }
                  />
                </Col>
            </Row>

            <Row className="pb-3 text-right">
              <Col>
                <Button variant="secondary"
                  className="mr-3"
                  onClick={ handleOnCancel }
                >
                  Cancelar
                </Button>

                <Button variant="primary"
                  disabled={ !isValid }
                  onClick={ handleOnAdd }
                >
                  Agregar complemento
                </Button>
              </Col>
            </Row>

          </Form>
        </div>
      </div>
    </>
  );
}

const rules  = {
  NumPerLicoAut: [
      'required',
      'string',
      'min:1',
      'max:40',
  ],
  Inmueble: {
    Calle: [
      'required',
      'string',
      'min:1',
      'max:150',
    ],
    NoExterior: [
        'string',
        'min:1',
        'max:55',
    ],
    NoInterior: [
        'string',
        'min:1',
        'max:30',
    ],
    Colonia: [
        'string',
        'min:1',
        'max:100',
    ],
    Localidad: [
        'string',
        'min:1',
        'max:100',
    ],
    Referencia: [
        'string',
        'min:1',
        'max:100',
    ],
    Municipio: [
        'required',
        'string',
        'min:1',
        'max:100',
    ],
    Estado: [
        'required',
        'string',
        'in:01,02,03,04,05,06,07,08,09,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32',
        'size:2',
    ],
    CodigoPostal: [
        'required',
        'string',
        'regex:/^[0-9]{5}$/',
    ],
  }
}

export default ComplementoParcialesConstruccion;